import PropTypes from 'prop-types';
import React from 'react';
import Button from '../../../../core/modules/common/components/Button';
import themeStyles from '../../../../materialUiTheme';
import TranslatedLink from './TranslatedLink';

// eslint-disable-next-line arrow-body-style
const ProgressButtons = ({ next }) => {
  return (
    <div>
      {next &&
      <TranslatedLink to={next.slice(next.lastIndexOf('/') + 1)}>
        <Button
          style={themeStyles.blueButton}
          text="app.button.next"
        />
      </TranslatedLink>}
    </div>
  );
};

export default ProgressButtons;

ProgressButtons.propTypes = {
  next: PropTypes.string,
};
